import useNavigate from '@/hooks/useNavigate';
import { DiagnosisCategoryType } from '@/models/diagnosis';
import { ECategoryType } from '@/services/doctor/DiagnosisCategoryService';
import { ROUTES } from '@/types/common';
import { isWebView } from '@/utils/mobile/RNPlugins';
import { useRouter } from 'next/router';

const COLD_TREATMENT_ID = '1';

const useQnaNativeDefaultViewModel = () => {
  const router = useRouter();
  const navigate = useNavigate();

  const onClickQnaNativeDefault = () => {
    if (isWebView()) {
      navigate.navigateToDoctorListAppScreen({ categoryId: COLD_TREATMENT_ID, type: DiagnosisCategoryType.Treatment });
      return;
    }
    router.push(ROUTES.TELEMEDICINE.DOCTORS.buildPath(ECategoryType.Treatment, COLD_TREATMENT_ID));
  };

  return {
    onClickQnaNativeDefault,
  };
};

export default useQnaNativeDefaultViewModel;
